import styled from 'styled-components';

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  row-gap: 8px;
  margin-top: 24px;
`;

export const TextWithToolTipContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: fit-content;
  align-items: top;
  gap: 8px;
`;

export const TooltipContainer = styled.div`
  display: flex;
  align-items: center;
  > div {
    display: flex;
    justify-content: center;
    height: 12px;
  }
`;
